import { IThemeConfig } from "../helpers";

const lightTheme: IThemeConfig = {
  name: "light",
  colors: {
    background: "#FFFFFF", // background color
    main: "#292934", // main text color
    secondary: "#52525D", // secondary text color
    action: "#7B3FE4", // action text color
    header: "#0A0A0D", // header color
    border: "#EEEEF2", // border/outline color
    hover: "rgba(195, 195, 195, 0.14)" // hover color
  }
};

export default lightTheme;
